<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']"
    titlePrefix="Zephyrcade - Digital Media Trading Platform"
    metaDescription="Zephyrcade is a digital media trading platform that connects advertisers and publishers. We provide efficient ad placement, real-time analytics, and smart optimization tools to maximize performance and revenue.">

    <section class="hero-section">
      <div class="hero-section__content">
        <h1 class="hero-section__title">Driving Results with<br>Intelligent Advertising</h1>
        <p class="hero-section__subtitle">
          From global ad placements to real-time performance insights, we provide customized
          solutions that connect your brand to the right audience and maximize ROI.
        </p>
        <a href="/#footer-section" class="hero-section__cta-button">
          <span>Contact Us</span>
          <img src="@/assets/banner-contact-arrow.svg" alt="arrow">
        </a>
      </div>
    </section>

    <section class="data-section">
      <div class="data-section__item" v-for="(item, index) in dataItems" :key="index">
        <div class="data-section__value">{{ item.value }}</div>
        <div class="data-section__label">{{ item.label }}</div>
      </div>
    </section>

    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Services we offer for you</h2>
        <p class="services-section__subtitle">
          We deliver premium advertising inventory to empower advertisers in scaling campaigns and
          achieving optimal ROI.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="why-section">
      <div class="why-section__header">
        <h2 class="why-section__title">Why choose us?</h2>
        <p class="why-section__subtitle">
          Trusted technology, expert support, and transparent service for your advertising success.
        </p>
      </div>
      <div class="why-section__content">
        <div class="why-section__image-container">
          <img src="@/assets/why.png" alt="Why choose us placeholder" class="why-section__image">
        </div>
        <div class="why-section__features">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <div class="feature-item__number">{{ index + 1 }}</div>
            <div class="feature-item__text">
              <h3 class="feature-item__title">{{ feature.title }}</h3>
              <p class="feature-item__description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section">
      <p class="trust-section__text">Trusted by Industry Leaders Worldwide</p>
    </section>

    <section class="partners-section">
      <div class="partners-section__header">
        <h2 class="partners-section__title">Partners</h2>
      </div>
      <div class="partners-section__grid">
        <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
          <img :src="partner.image" :alt="partner.name">
        </div>
      </div>
    </section>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {
      dataItems: [
        { value: '1B+', label: 'Monthly ad impressions delivered to targeted audiences.' },
        { value: '99.9%', label: 'Ad account approval rate ensuring smooth campaign launches.' },
        { value: '24/7', label: 'Real-time monitoring for uninterrupted ad performance.' }
      ],
      services: [
        {
          title: 'Premium Inventory Access',
          description: 'Gain access to high-quality ad placements across trusted publishers and premium digital channels.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Real-Time Bidding',
          description: 'Leverage advanced programmatic technology to bid efficiently and reach your audience at the right moment.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Campaign Optimization',
          description: 'Maximize performance with data-driven strategies, continuous testing, and smart targeting adjustments.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Dedicated Support',
          description: 'Work with an expert team that provides 24/7 assistance, ensuring smooth execution and measurable results.',
          image: require('@/assets/service-4.png')
        }
      ],
      features: [
        {
          title: 'Comprehensive Platform Access',
          description: 'We provide seamless access to major advertising platforms worldwide, ensuring your campaigns reach the right audience.'
        },
        {
          title: 'Expert Support Team',
          description: 'Our experienced professionals offer personalized guidance and quick problem-solving to keep your campaigns running smoothly.'
        },
        {
          title: 'Transparent and Efficient Trading',
          description: 'With real-time bidding and clear reporting, we guarantee fair pricing and maximize your advertising ROI.'
        }
      ],
      partners: [
        { name: 'Amazon', image: require('@/assets/Amazon.png') },
        { name: 'Yandex', image: require('@/assets/Yandex.png') },
        { name: 'Zalora', image: require('@/assets/Zalora.png') },
        { name: 'Google', image: require('@/assets/Google.png') },
        { name: 'Tinder', image: require('@/assets/Tinder.png') },
        { name: 'Meta', image: require('@/assets/Meta.png') },
        { name: 'Telecoming', image: require('@/assets/Telecoming.png') },
        { name: 'TikTok', image: require('@/assets/TikTok.png') }
      ]
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

  }
};
</script>

